import { render, staticRenderFns } from "./DocumentSendEmail.vue?vue&type=template&id=d4b1b98e&scoped=true&"
import script from "./DocumentSendEmail.vue?vue&type=script&lang=js&"
export * from "./DocumentSendEmail.vue?vue&type=script&lang=js&"
import style0 from "./DocumentSendEmail.vue?vue&type=style&index=0&id=d4b1b98e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4b1b98e",
  null
  
)

export default component.exports